import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageSquare, Menu, X } from "lucide-react";
import { BIZ } from "@/data/business";
import { scrollToId } from "./SmoothScroll";
import { EASE } from "./motion";

const LINKS = [
  ["services", "Services"], ["pricing", "Pricing"], ["tint-picker", "Tint"], ["mobile", "Mobile"], ["contact", "Contact"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.9, ease: EASE, delay: 1.6 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${scrolled ? "bg-[#07080B]/75 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"}`}
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 h-[72px] flex items-center justify-between gap-6">
        <button onClick={() => go("top")} data-testid="header-logo" className="flex items-center gap-3 group">
          <img src="/velocity-badge.png" alt="Velocity Detailing logo" className="h-11 w-auto transition-transform duration-500 group-hover:rotate-[-6deg]" />
          <span className="hidden sm:block font-display font-extrabold text-sm tracking-tight leading-none">VELOCITY<br /><span className="text-[#6fd6ff] font-mono font-normal text-[10px] tracking-[0.3em]">DETAILING</span></span>
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([id, l]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="relative font-mono text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-white transition-colors group">
              {l}<span className="absolute -bottom-1.5 left-0 h-px w-full origin-left scale-x-0 bg-[#1bb4f2] transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={BIZ.tel} data-testid="nav-call-button" className="hidden md:inline-flex items-center gap-2 h-10 px-4 border border-white/15 hover:border-[#1bb4f2] text-sm transition-colors"><Phone className="h-4 w-4 text-[#1bb4f2]" />{BIZ.phone}</a>
          <a href={BIZ.sms} data-testid="nav-text-button" className="hidden md:inline-flex items-center gap-2 h-10 px-4 border border-white/15 hover:border-[#1bb4f2] text-sm transition-colors"><MessageSquare className="h-4 w-4 text-[#1bb4f2]" />Text</a>
          <button onClick={() => go("quote")} data-testid="nav-quote-button" className="hidden sm:inline-flex h-10 items-center px-5 bg-[#1bb4f2] text-[#07080B] font-semibold text-sm hover:bg-white transition-colors">Request a Quote</button>
          <button onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" className="lg:hidden h-10 w-10 grid place-items-center border border-white/15" aria-label="Menu">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} transition={{ duration: 0.5, ease: EASE }} className="lg:hidden overflow-hidden bg-[#07080B]/95 backdrop-blur-xl border-t border-white/10">
            <div className="px-5 py-6 flex flex-col gap-4">
              {LINKS.map(([id, l]) => (
                <button key={id} onClick={() => go(id)} data-testid={`mobile-nav-${id}`} className="text-left font-display font-black text-3xl uppercase">{l}</button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
